import e from "../../utilityStyles.module.js";
import { Column as t } from "../Layout/Column.js";
import { useFormField as n } from "./useFormField.js";
import { Row as r } from "../Layout/Row.js";
import { Typography as i } from "../Typography/Typography.js";
import "react";
import { jsxDEV as a } from "react/jsx-dev-runtime";
import { WarningCircleIcon as o } from "@phosphor-icons/react";
//#region lib/components/FormField/FormField.tsx
var s = "/opt/render/project/src/shared-ui/lib/components/FormField/FormField.tsx";
function c({ id: c, label: l, helpText: u, errorMessage: d, containerProps: f, children: p }) {
	let { fieldId: m, hasError: h, hasHelpText: g, helpTextId: _, errorMessageId: v } = n({
		id: c,
		helpText: u,
		errorMessage: d
	});
	return /* @__PURE__ */ a(t, {
		spacing: 1,
		...f,
		children: [
			l && /* @__PURE__ */ a(i, {
				variant: "heading-small",
				children: /* @__PURE__ */ a("label", {
					htmlFor: m,
					children: l
				}, void 0, !1, {
					fileName: s,
					lineNumber: 23,
					columnNumber: 21
				}, this)
			}, void 0, !1, {
				fileName: s,
				lineNumber: 22,
				columnNumber: 17
			}, this),
			g && /* @__PURE__ */ a(i, {
				id: _,
				variant: "caption",
				className: e.colorNeutralText,
				children: u
			}, void 0, !1, {
				fileName: s,
				lineNumber: 28,
				columnNumber: 17
			}, this),
			p,
			h && /* @__PURE__ */ a(r, {
				spacing: 1,
				className: e.colorErrorText,
				role: "alert",
				children: [/* @__PURE__ */ a(o, {
					size: 12,
					"aria-hidden": !0
				}, void 0, !1, {
					fileName: s,
					lineNumber: 37,
					columnNumber: 21
				}, this), /* @__PURE__ */ a(i, {
					id: v,
					variant: "caption",
					children: d
				}, void 0, !1, {
					fileName: s,
					lineNumber: 38,
					columnNumber: 21
				}, this)]
			}, void 0, !0, {
				fileName: s,
				lineNumber: 36,
				columnNumber: 17
			}, this)
		]
	}, void 0, !0, {
		fileName: s,
		lineNumber: 20,
		columnNumber: 9
	}, this);
}
//#endregion
export { c as FormField };
